import WebLayout from './RequestOptInButtonLayout.web';
import MobileLayout from './RequestOptInButtonLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative()  ? MobileLayout : WebLayout;
